import { render } from "./RareDiseaseComorbidity.vue?vue&type=template&id=76a83e28&scoped=true"
import script from "./RareDiseaseComorbidity.vue?vue&type=script&lang=js"
export * from "./RareDiseaseComorbidity.vue?vue&type=script&lang=js"

import "./RareDiseaseComorbidity.vue?vue&type=style&index=0&id=76a83e28&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a83e28"]])

export default __exports__